import { SiteSessionService } from "../../core/services/SiteSessionService";
import axios from "axios";
export class ApiHelper {
    private static apiBaseURL = () => process.env.REACT_APP_BACKEND_API!;

    public static async callApi(url: any, data: any, method: string) {
        return this.callFetch(url, data, method).then((res) => this.getResponseData(res));
    }

    public static async postApi(url: any, data: any) {
        const response = await this.callFetch(url, data, "POST");
        return response;
    }

    public static async postMultiPartData(url: any, formData: FormData, files: File[]) {        

        for (let i = 0; i < files.length; i++) {
            const file = files[i];
            formData.append("file", file, file.name);
        }        

        const response = await axios.post(this.apiBaseURL() + url, formData, {
            headers: {
                Authorization: ApiHelper.getBearerToken(),
                "Content-Type": "multipart/form-data",                
                UserId: SiteSessionService.getUserID(),
            },
        });

        return response;
    }

    public static async get(url: any) {
        const request = new Request(this.apiBaseURL() + url, {
            cache: "no-store",
            headers: {
                Accept: "application/json",                
                Authorization: ApiHelper.getBearerToken(),
                UserId: SiteSessionService.getUserID(),
            },
            method: "get",
            mode: "cors",
        });
        const response = await fetch(request);
        return ApiHelper.getResponseData(response);
    }

    public static getUrlTokenParameter() {
        return `access_token=${SiteSessionService.getAccessToken()}`;
    }

    public static getBearerToken() {
        return `Bearer ${SiteSessionService.getAccessToken()}`;
    }

    public static callFetch(url: any, data: any = {}, method: string) {
        return fetch(this.apiBaseURL() + url, {
            body: JSON.stringify(data), // body data type must match "Content-Type" header
            cache: "no-cache", // *default, no-cache, reload, force-cache, only-if-cached
            //credentials: "same-origin", // include, *same-origin, omit
            headers: {
                "Content-Type": "application/json; charset=utf-8",
                Authorization: ApiHelper.getBearerToken(),                
                UserId: SiteSessionService.getUserID(),
            },
            method: method, // *GET, POST, PUT, DELETE, etc.
            mode: "cors", // no-cors, cors, *same-origin
            redirect: "follow", // manual, *follow, error
            referrer: "no-referrer", // no-referrer, *client
        });
    }

    private static getResponseData(response: Response) {
        var result;
        switch (response.status) {
            case 204:
            case 400:
            case 500:
            case 404:
                result = undefined;
                break;
            default:
                result = response.json();
                break;
        }
        return result;
    }    
}
